import SalaryHistory from "./salaryHistory";
export default SalaryHistory;